<template>
    <tr>
        <td>
            {{card.rewardName}}
        </td>
        <td>
            {{card.currencyCode}}
        </td>
        <td>
            <div v-if="card.valueType === 'VARIABLE_VALUE'">
            {{minValue}} {{card.currency}} to
            {{maxValue}} {{card.currency}}
            </div>
            <div v-if="card.valueType === 'FIXED_VALUE'">
                {{card.faceValue}}
            </div>
        </td>
        <td>
            <v-btn color="primary">Select</v-btn>
        </td>
    </tr>
</template>

<script>
    export default {

        props: {
            card: {
                type: Object,
                required: true
            }
        },

        data() {
            return {

            }
        },

        computed: {

        }
    }
</script>

<style scoped>

</style>